/* 6FT Club - homepage research cards: makes each card's image a link to the
   blog article (added 2026-10-06). The article address comes from each card's
   "Full article" setting in the Stats cards section; cards without a published
   article stay as they are. */
(function () {
  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.sc-card'), function (card) {
      if (card.querySelector('.sc-media__link')) return;
      var opener = card.querySelector('[data-sc-story-open]');
      var media = card.querySelector('.sc-media');
      if (!opener || !media) return;
      var dlg = document.getElementById(opener.getAttribute('data-sc-story-open'));
      var more = dlg && dlg.querySelector('.sc-story__more');
      if (!more || !more.getAttribute('href')) return;

      var label = (opener.textContent || '').replace(/→/g, '').trim() || 'Read the story';
      var titleEl = dlg.querySelector('.sc-story__title');
      var a = document.createElement('a');
      a.className = 'sc-media__link';
      a.href = more.getAttribute('href');
      a.setAttribute('aria-label', label + (titleEl ? ': ' + titleEl.textContent.trim() : ''));
      media.appendChild(a);
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();